// Chemins relatifs à la base `/api/v1` du client HTTP (comme `kybCorporateAccessEndpoints`).
const base = "/compliance/kyb/corporate-access-recertifications";

const kybAccessRecertificationEndpoints = {
  /** `status` se répète pour demander plusieurs états ; sans lui, le back rend les tâches ouvertes. */
  list: (statuses: string[] = []) => {
    if (statuses.length === 0) {
      return base;
    }
    const query = statuses.map((status) => "status=" + encodeURIComponent(status)).join("&");
    return base + "?" + query;
  },
  decisions: `${base}/decisions`,
  settings: `${base}/settings`,
  mfaChallenge: `${base}/mfa-challenge`,
  reactivation: (recertificationId: string) => `${base}/${recertificationId}/reactivation`,
};

export default kybAccessRecertificationEndpoints;
